import * as React from "react";
import { Lock, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { useTariff } from "../lib/use-tariff";

interface FeatureGateProps {
  feature: string;
  // Eng past mos tarif metadata'si upsell matnida ko'rsatiladi.
  requiredTariff?: "standard" | "comfort" | "pro" | "max";
  children: React.ReactNode;
  onUpgrade?: () => void;
}

export function FeatureGate({
  feature,
  requiredTariff = "pro",
  children,
  onUpgrade,
}: FeatureGateProps) {
  const { has } = useTariff();
  if (has(feature)) return <>{children}</>;
  return <UpgradePrompt requiredTariff={requiredTariff} onUpgrade={onUpgrade} />;
}

interface UpgradePromptProps {
  requiredTariff: "standard" | "comfort" | "pro" | "max";
  onUpgrade?: () => void;
  className?: string;
}

export function UpgradePrompt({
  requiredTariff,
  onUpgrade,
  className,
}: UpgradePromptProps) {
  const { t } = useTranslation("common");
  const label = t(`tariff.labels.${requiredTariff}`);
  return (
    <Card className={className}>
      <CardContent className="flex flex-col items-center text-center py-12 gap-4">
        <div className="size-14 rounded-full bg-primary/10 text-primary flex items-center justify-center">
          <Lock className="size-6" />
        </div>
        <div className="space-y-1.5">
          <h2 className="text-lg font-semibold">
            {t("gate.title", { tariff: label })}
          </h2>
          <p className="text-sm text-muted-foreground max-w-md">
            {t("gate.desc")}
          </p>
        </div>
        {onUpgrade && (
          <Button onClick={onUpgrade} className="mt-2">
            <Sparkles className="size-4" />
            {t("gate.upgrade")}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
